import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../../config/config.service';
import { DepositoResponsavel } from '../../../../../types/DepositoResponsavel.type';
import { Page } from '../../../../../types/Page.type';

@Injectable({
  providedIn: 'root'
})
export class DepositoResponsavelService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll(page: number, size: number, sortField: string, sortDirection: string) {
    return this.httpClient.get<Page<DepositoResponsavel>>(
      `${this.configService.getApiUrlRoot()}/transfinsumos/depositos-responsaveis/?page=${page}&size=${size}&sort=${sortField},${sortDirection}`
    );
  }

  post(body: DepositoResponsavel) {
    return this.httpClient.post<DepositoResponsavel>(
      `${this.configService.getApiUrlRoot()}/transfinsumos/depositos-responsaveis/`, body
    );
  }

  put(id: number, body: DepositoResponsavel) {
    return this.httpClient.put<DepositoResponsavel>(
      `${this.configService.getApiUrlRoot()}/transfinsumos/depositos-responsaveis/${id}`, body
    );
  }

  delete(id: number) {
    return this.httpClient.delete(
      `${this.configService.getApiUrlRoot()}/transfinsumos/depositos-responsaveis/${id}`
    );
  }
}
